import { FunctionCloneDeep } from "radium-omnibus";
import api from "../../../utils/useApi";
import AviableAddress from "../../../utils/useAviableAddress";
import {
  FunctionCheckArea,
  FunctionCheckIsBKK,
} from "../../../utils/useFunction";

const AddressGetLatLngOnSelected = async (
  setSelectedLocation,
  location,
  setTempLocation
) => {
  try {
    if (location) {
      const { data } = await api.post("/address/detail", {
        placeId: location?.place_id,
      });

      let temp = FunctionCloneDeep({ ...location });

      temp = {
        ...temp,
        ...data?.address?.result,
        lat: data?.address?.result?.geometry?.location?.lat,
        lng: data?.address?.result?.geometry?.location?.lng,
        link: data?.address?.result?.url,
        isAvailable: FunctionCheckArea(AviableAddress, {
          lat: data?.address?.result?.geometry?.location?.lat,
          lng: data?.address?.result?.geometry?.location?.lng,
        }),
        location: FunctionCheckIsBKK(data?.address?.result?.address_components),
      };

      setSelectedLocation({ ...temp });
      setTempLocation({ ...temp });
    }
    return;
  } catch (error) {
    console.log("AddressGetLatLngOnSelected : ", error);
  }
};

export default AddressGetLatLngOnSelected;
